export const toGroupOptions = list => {
  if (!list) return []

  return [
    {
      label: 'Public',
      options: list.filter(l => l.isPublic)
    },
    {
      label: 'Private',
      options: list.filter(l => !l.isPublic)
    }
  ]
}
